function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.52832 9.52734C0.52832 5.40349 3.90446 2.02734 8.02832 2.02734C12.1522 2.02734 15.5283 5.40349 15.5283 9.52734C15.5283 13.6512 12.1522 17.0273 8.02832 17.0273C3.90446 17.0273 0.52832 13.6512 0.52832 9.52734Z",
  fill: "#565657",
  stroke: "#565657"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.58121 5.16334L8.44921 11.1633H7.53721L7.40521 5.16334H8.58121ZM8.04121 13.5993C7.83321 13.5993 7.65721 13.5273 7.51321 13.3833C7.36921 13.2393 7.29721 13.0633 7.29721 12.8553C7.29721 12.6473 7.36921 12.4713 7.51321 12.3273C7.65721 12.1833 7.83321 12.1113 8.04121 12.1113C8.24121 12.1113 8.40921 12.1833 8.54521 12.3273C8.68921 12.4713 8.76121 12.6473 8.76121 12.8553C8.76121 13.0633 8.68921 13.2393 8.54521 13.3833C8.40921 13.5273 8.24121 13.5993 8.04121 13.5993Z",
  fill: "white"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17,
  height: 18,
  fill: "white",
  transform: "translate(0 0.533203)"
})));

function SvgTooltip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.10b71177.svg";
export { ForwardRef as ReactComponent };